import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';

import Dropdown from '../../../components/Dropdown';
import Button from '../../../components/Button';
import withHostContext, {
  trackingCategories,
  trackingLabels,
  trackingLocations,
  trackClick,
  trackEventGa,
} from '../../../context/host/consumer';
import CollegeContacts from '../../CollegeContacts';
import './styles.css';
import { getUrlWithProtocol } from '../../../utils/url';

const messages = defineMessages({
  communicate: {
    id: 'hubs.weblinks.communicate',
    defaultMessage: 'Communicate',
  },
  requestInformation: {
    id: 'hubs.weblinks.request-information',
    defaultMessage: 'Request Information',
  },
  contactAdmissions: {
    id: 'hubs.weblinks.contact-admissions-office',
    defaultMessage: 'Send a message to the admissions office',
  },
});

class CommunicateLink extends React.PureComponent {
  static propTypes = {
    premium_links: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
    intl: PropTypes.object,
    collegeContact: PropTypes.arrayOf(PropTypes.object),
    openAdmissionsModal: PropTypes.func,
    sendEmail: PropTypes.func,
    userEmail: PropTypes.string,
    collegeName: PropTypes.string,
  };

  state = {
    isOpenContactModal: false,
    dropdownOpen: false,
  };

  getLinkContent = (link) => {
    return (
      <a
        data-cy={'weblinks-requestinfo-link'}
        href={getUrlWithProtocol(link.url)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage {...messages.requestInformation} />
      </a>
    );
  };

  getCommunicateBtn = () => {
    return (
      <Button
        className="contact-admissions-btn"
        data-cy={'weblinks-contact-admissions-btn'}
        onClick={this.handleCommunicate}
      >
        <FormattedMessage {...messages.contactAdmissions} />
      </Button>
    );
  };

  handleRequestInfoClick = (productId) => {
    if (productId) {
      trackClick(this.props.hostContext, {
        productId,
        location: trackingLocations.REQUEST_INFO,
      });
    }
    trackEventGa(this.props.hostContext, {
      type: 'click',
      category: trackingCategories.TOP_RIGHT_NAV,
      label: trackingLabels.COMMUNICATE_REQUEST_INFO,
    });
  };

  handleCommunicate = () => {
    trackEventGa(this.props.hostContext, {
      type: 'click',
      category: trackingCategories.TOP_RIGHT_NAV,
      label: trackingLabels.COMMUNICATE_ADMISSIONS,
    });
    this.props.openAdmissionsModal();
  };

  toggleContactModal = (label = null) => {
    if (label && !this.state.isOpenContactModal) {
      trackEventGa(this.props.hostContext, {
        type: 'click',
        category: trackingCategories.TOP_RIGHT_NAV,
        label,
      });
    }
    this.setState(({ isOpenContactModal }) => ({
      isOpenContactModal: !isOpenContactModal,
    }));
  };

  handleOpen = (e) => {
    this.setState({ dropdownOpen: true });
    trackEventGa(this.props.hostContext, {
      type: 'click',
      category: trackingCategories.TOP_RIGHT_NAV,
      label: trackingLabels.COMMUNICATE,
    });
  };

  handleClose = () => {
    this.setState({ dropdownOpen: false });
  };

  render() {
    const {
      premium_links,
      collegeContact,
      className,
      sendEmail,
      userEmail,
      collegeName,
      openAdmissionsModal,
    } = this.props;
    const { dropdownOpen } = this.state;
    const communicateLink = []
      .concat(premium_links || [])
      .find((link) => link.category === 'COMMUNICATE');
    const hasContacts = collegeContact && collegeContact.length > 0;
    const showAdmissions = openAdmissionsModal !== null;
    const showDropdown = communicateLink || hasContacts;

    return (
      <React.Fragment>
        {showDropdown && (
          <Dropdown
            data-cy={'weblinks-communicate-dropdown'}
            text={this.props.intl.formatMessage(messages.communicate)}
            icon={`caret ${dropdownOpen ? 'up' : 'down'}`}
            tabIndex={0}
            aria-label="Communicate"
            className={classNames('weblinks-communicate-dropdown', className)}
            onOpen={this.handleOpen}
            onClose={this.handleClose}
          >
            <Dropdown.Menu direction="right">
              {communicateLink && (
                <React.Fragment>
                  <Dropdown.Item
                    content={this.getLinkContent(communicateLink)}
                    onClick={() =>
                      this.handleRequestInfoClick(communicateLink.product_id)
                    }
                  />
                  <Dropdown.Divider />
                </React.Fragment>
              )}
              {hasContacts && (
                <React.Fragment>
                  <Dropdown.Item
                    data-cy="weblinks-contacts-option"
                    content="Get in touch with your college contact"
                    onClick={() =>
                      this.toggleContactModal(trackingLabels.COMMUNICATE_CONTACTS)
                    }
                  />
                  <Dropdown.Divider />
                </React.Fragment>
              )}
              {showAdmissions && <Dropdown.Item content={this.getCommunicateBtn()} />}
            </Dropdown.Menu>
          </Dropdown>
        )}
        {!showDropdown && showAdmissions && (
          <Button
            data-cy="weblinks-communicate-button"
            role="button"
            title="Communicate with college button"
            aria-label="Communicate with college button"
            className={className ? className : 'communicate-btn'}
            tabIndex="0"
            onClick={this.handleCommunicate}
          >
            <FormattedMessage {...messages.communicate} />
          </Button>
        )}
        {this.state.isOpenContactModal ? (
          <CollegeContacts
            open={this.state.isOpenContactModal}
            handleClose={this.toggleContactModal}
            sendEmail={sendEmail}
            collegeContacts={collegeContact}
            userEmail={userEmail}
            collegeName={collegeName}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default injectIntl(withHostContext(CommunicateLink));
